class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onAdd);
  }
  onAdd() {
    this.classList.add('loading');
    var variantId = this.getAttribute('data-variant-id');
    var quantity = this.getAttribute('data-quantity');
    const cartDrawer = document.querySelector('cart-drawer');

    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity ? quantity : 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.classList.remove('loading');
        const cartBtn = this;
        if (cartItems) {
          cartItems.onCartUpdate();
        }
        if (cartDrawer) {
          cartDrawer.setHeaderCartIconAccessibility();
          cartDrawer.open();
        }

        fetch('/cart.js')
          .then((response) => response.json())
          .then((data) => {

            const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important; stroke-linecap:round !important; stroke-linejoin:round !important;">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important;"/>
              <path d="M3 6h18" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important;"/>
              <path d="M16 10a4 4 0 0 1-8 0" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important;"/>
            </svg>
                <span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span><span class="visually-hidden">${data.item_count} item</span></div>`;

          const icon2 = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important; stroke-linecap:round !important; stroke-linejoin:round !important;">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important;"/>
              <path d="M3 6h18" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important;"/>
              <path d="M16 10a4 4 0 0 1-8 0" style="fill:none !important; stroke:#1F1A17 !important; stroke-width:2 !important;"/>
            </svg>
                <span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span><span class="visually-hidden">${data.item_count} item</span></div>
                `;

            if(document.querySelector('#cart-icon-bubble')){
              document.querySelector(
                '#cart-icon-bubble'
              ).innerHTML = icon;
            }
            if(document.querySelector('#cart-icon-bubble-mobile')){
              document.querySelector(
                '#cart-icon-bubble-mobile'
              ).innerHTML = icon;
            }
            if(document.querySelector('#cart-icon-bubble-info')){
              document.querySelector(
                '#cart-icon-bubble-info'
              ).innerHTML = icon2;
            }
            // handleModal();
            // handleTermCheckbox();
            
          })
          .catch((error) => console.error('Error fetching cart data:', error));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}
customElements.define('add-to-cart', AddToCart);
